import { ClientShoppingProvider, PaginationParams } from 'types';

export const NOTIFICATIONS_PER_PAGE = 25;

export const defaultNotificationsPaginationParams: PaginationParams = {
  perPage: NOTIFICATIONS_PER_PAGE,
  page: 0,
};

export const defaultSettings: ClientShoppingProvider = {
  connected: false,
  syncStatus: undefined,
  apiKey: '',
  shopName: '',
  password: '',
  storefrontAccessToken: '',
  sharedSecret: '',
  shopifyMultipassSecret: '',
  shopifyMultipassUrl: '',
};
